<div class="side-nav">
  <!-- Brand -->
  <div class="brand">
    <svg class="brand-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-linecap="round" stroke-linejoin="round" width="28" height="28" stroke-width="2">
      <path d="M2 9a10 10 0 1 0 20 0"></path>
      <path d="M12 19a10 10 0 0 1 10 -10"></path>
      <path d="M2 9a10 10 0 0 1 10 10"></path>
      <path d="M12 4a9.7 9.7 0 0 1 2.99 7.5"></path>
      <path d="M9.01 11.5a9.7 9.7 0 0 1 2.99 -7.5"></path>
    </svg>
    <span class="brand-wordmark">{{ app_title }}</span>
  </div>

  <ng-container *ngIf="isAuthenticated; else unauthNav">
    <!-- Nav list -->
    <nav class="nav-list">
      <a class="nav-item" data-testid="side-nav-upload" routerLink="/files/upload" routerLinkActive="nav-item--active">
        <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
          <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
          <path d="M7 9l5 -5l5 5"></path>
          <path d="M12 4l0 12"></path>
        </svg>
        <span class="nav-label">Upload</span>
      </a>

      <a class="nav-item" data-testid="side-nav-folders" routerLink="/files/folders" routerLinkActive="nav-item--active">
        <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
          <path d="M5 4h4l3 3h9a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2"></path>
        </svg>
        <span class="nav-label">Folders</span>
        <span class="nav-badge" *ngIf="pending_review_count > 0" data-testid="side-nav-badge-pending-reviews">
          {{ pending_review_count }}
        </span>
      </a>

      <a class="nav-item" data-testid="side-nav-households" routerLink="/users/households"
        routerLinkActive="nav-item--active"
        *roleAccess="[UserRole.SUPER_ADMIN, UserRole.SUPERVISOR, UserRole.MANAGER, UserRole.ADVISOR]">
        <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
          <path d="M5 12l-2 0l9 -9l9 9l-2 0"></path>
          <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
          <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"></path>
        </svg>
        <span class="nav-label">Households</span>
      </a>

      <a class="nav-item" data-testid="side-nav-firm-page" routerLink="/firm"
        routerLinkActive="nav-item--active"
        *roleAccess="[UserRole.SUPER_ADMIN, UserRole.SUPERVISOR, UserRole.MANAGER, UserRole.ADVISOR]">
        <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
          <path d="M3 21l18 0"></path>
          <path d="M5 21v-14l8 -4v18"></path>
          <path d="M19 21v-10l-6 -4"></path>
          <path d="M9 9l0 .01"></path>
          <path d="M9 12l0 .01"></path>
          <path d="M9 15l0 .01"></path>
          <path d="M9 18l0 .01"></path>
        </svg>
        <span class="nav-label">Firm</span>
      </a>

      <a class="nav-item" data-testid="side-nav-osj" routerLink="/osj"
        routerLinkActive="nav-item--active"
        *roleAccess="[UserRole.SUPER_ADMIN, UserRole.SUPERVISOR]">
        <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
          <path d="M5 4h14v6.5c0 3 -2.5 7 -7 10c-4.5 -3 -7 -7 -7 -10v-6.5z"></path>
          <path d="M9 12l2 2l4 -4"></path>
        </svg>
        <span class="nav-label">OSJ</span>
      </a>

      <a class="nav-item" data-testid="side-nav-users-list" routerLink="/users-list"
        routerLinkActive="nav-item--active"
        *roleAccess="[UserRole.SUPER_ADMIN, UserRole.SUPERVISOR, UserRole.MANAGER, UserRole.ADVISOR]">
        <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
          <path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"></path>
          <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          <path d="M21 21v-2a4 4 0 0 0 -3 -3.85"></path>
        </svg>
        <span class="nav-label">Users</span>
      </a>

      <a class="nav-item" data-testid="side-nav-administration" routerLink="/users/admin"
        routerLinkActive="nav-item--active"
        *roleAccess="[UserRole.SUPER_ADMIN, UserRole.SUPERVISOR]">
        <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
          <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"></path>
          <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
        </svg>
        <span class="nav-label">Administration</span>
      </a>

      <ng-container *roleAccess="[UserRole.SUPERVISOR, UserRole.SUPER_ADMIN]">
        <div class="nav-divider"></div>
        <div class="nav-item firm-item" data-testid="side-nav-firm" (click)="onFirmPickerClick()">
          <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
            <path d="M12 2l9 4.5l-9 4.5l-9 -4.5z"></path>
            <path d="M3 11.5l9 4.5l9 -4.5"></path>
            <path d="M3 16.5l9 4.5l9 -4.5"></path>
          </svg>
          <div>
            <div class="nav-label">Current Firm</div>
            <ng-container *ngIf="(activeGroup$ | async) as activeGroup; else orgOnlyLabel">
              <div class="nav-subtitle">{{ activeGroup.GROUP_NAME }}</div>
              <div class="nav-subtitle">{{ (activeOrg$ | async)?.ORGANIZATION_NAME }}</div>
            </ng-container>
            <ng-template #orgOnlyLabel>
              <div class="nav-subtitle">{{ (activeOrg$ | async)?.ORGANIZATION_NAME }}</div>
            </ng-template>
          </div>
        </div>
      </ng-container>
    </nav>

    <!-- Spacer -->
    <div class="spacer"></div>

    <!-- User row -->
    <div class="user-row-wrapper">
      <a class="user-row" data-testid="side-nav-user-row" routerLink="/users/me">
        <div class="user-avatar">{{ userInitial }}</div>
        <div class="user-info">
          <div class="user-name">{{ current_user?.USER?.FIRST_NAME }}</div>
          <div class="user-org">{{ (displayOrganization$ | async)?.ORGANIZATION_NAME || '—' }}</div>
          <div class="user-role">{{ current_user?.USER?.ROLE }}</div>
        </div>
      </a>
      <button class="user-logout-btn" data-testid="side-nav-logout" title="Log out" (click)="logout()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-linecap="round" stroke-linejoin="round" stroke-width="2" width="16" height="16">
          <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"></path>
          <path d="M9 12h12l-3 -3m0 6l3 -3"></path>
        </svg>
      </button>
    </div>
  </ng-container>

  <!-- Unauthenticated -->
  <ng-template #unauthNav>
    <nav class="nav-list">
      <a class="nav-item" data-testid="side-nav-login" routerLink="/auth/login" routerLinkActive="nav-item--active">
        <span class="nav-label">Log In</span>
      </a>
      <a class="nav-item" data-testid="side-nav-signup" routerLink="/auth/signup" routerLinkActive="nav-item--active">
        <span class="nav-label">Sign Up</span>
      </a>
    </nav>
  </ng-template>
</div>
